import { Component, OnInit,Output,EventEmitter } from '@angular/core';

@Component({
  selector: 'app-modulo-retencion-sidebar',
  templateUrl: './modulo-retencion-sidebar.component.html',
  styleUrls: ['./modulo-retencion-sidebar.component.scss']
})
export class ModuloRetencionSidebarComponent implements OnInit {
  @Output() selecttab = new EventEmitter<String>();
  constructor() { }

  ngOnInit(): void {
  }
  selectedtab(tab): void {
    this.selecttab.emit(tab)
  }
}
